import FONDO from "../assets/ONEE.png";

const SectionOne = () => {
  return (
    <div
      className="relative w-full h-[75vh] overflow-hidden bg-cover bg-center grid grid-cols-1 md:grid-cols-2"
      style={{ backgroundImage: `url(${FONDO})` }}
    >
      <div className="w-full h-full flex flex-col justify-center p-4 md:p-16 text-white z-40">
        <h1 className="text-2xl md:text-5xl font-bold">Distribuidora</h1>
        <h1 className="text-2xl md:text-5xl font-bold">Empresarial</h1>
        <p className="text-sm md:text-base mt-6">
          Somos una empresa multidisciplinaria e interdisciplinaria que presta servicios a los sectores empresariales,
          industriales, productores y en general a toda organización que requiera de una fuerza profesional operativa y
          efectiva para logro de sus objetivos corporativos empresariales.
        </p>
      </div>
      <div className="absolute inset-0 bg-black/30 z-30" />
    </div>
  );
};

export default SectionOne;
